import React from "react";
import * as actions from "../actions/actions";
import { connect } from "react-redux";

import { hashHistory } from "react-router";
import Icon from "./nounproject-ui-icon";

class PluginToolbar extends React.Component {

    goToAbout(e) {
        e.preventDefault();
        hashHistory.push("about");
    }

    goToMenu(e) {
        e.preventDefault();
        hashHistory.push("menu");
    }

    goToFeedback(e) {
        e.preventDefault();
        hashHistory.push("feedback");
    }

    goToSettings(e) {
        e.preventDefault();
        hashHistory.push("billing");
    }

    goToLogin(e) {
        e.preventDefault();
        hashHistory.push("login");
    }

    render(){
        let authBtn;

        if (this.props.currentUser !== undefined) {
            if (this.props.currentUser.is_anonymous) {
                authBtn = (
                    <a
                        href="#"
                        onClick={this.goToLogin.bind(this)}
                        className="plugin-button"
                        style={{ color: "white" }}
                    >
                        <span className="padding-l-m padding-r-m">
                            Log in to Noun Project
                        </span>
                    </a>
                );
            } else {
                authBtn = (
                    <a
                        href="#"
                        onClick={this.goToMenu.bind(this)}
                        className="plugin-button"
                        title="Settings menu"
                    >
                        <Icon
                            iconId="cog.svg"
                            className="icon-14"
                            color="#FFFFFF"
                        />
                    </a>
                );
            }
        }

        return (
            <div className="plugin-tool-bar">
                {authBtn}
                <a
                    href="#"
                    title="Learn about Noun Project"
                    className="plugin-button"
                    onClick={this.goToAbout.bind(this)}
                >
                    <Icon
                        iconId="help.svg"
                        className="icon-14"
                        color="#FFFFFF"
                    />
                </a>
                <a
                    href="#"
                    title="Give feedback"
                    className="plugin-button"
                    onClick={this.goToFeedback.bind(this)}
                >
                    <Icon
                        iconId="feedback.svg"
                        className="icon-14"
                        color="#FFFFFF"
                    />
                </a>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let currentUser,
        host = state.plugin.host,
        page = state.plugin.page,
        totalIcons = state.icons.search_total;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return {
        currentUser,
        host,
        page,
        totalIcons
    };
}

module.exports = connect(mapStateToProps, {
    setPage: actions.setPage
})(PluginToolbar);
